import ZkInputNumber from './src/input-number';

/* istanbul ignore next */
ZkInputNumber.install = function(Vue) {
  Vue.component(ZkInputNumber.name, ZkInputNumber);
};

export default ZkInputNumber;



// WEBPACK FOOTER //
// ./src/packages/input-number/index.js